/**
 * Throttle an eventhandler to only fire every X ms
 * usage: addEventListener('mousemove', throttle(logMousePosition, 300));
 * @see https://programmingwithmosh.com/javascript/javascript-throttle-and-debounce-patterns/
 * @param {function} callback 
 * @param {int} interval ms
 * @return {function}
 */
export default function throttle(callback, interval) {
	let enableCall = true;

	return function (...args) {
		if (!enableCall) return;

		enableCall = false;
		callback.apply(this, args);
		setTimeout(() => enableCall = true, interval);
	}
}